const loadMoreConversations = (state, action) => {
  const { status } = action;
  switch (status) {
    case 'started': {
      return {
        ...state,
        loadingMoreConversations: true,
      };
    }
    case 'success': {
      const {
        payload: { conversations, totalCount, page },
      } = action;

      // If it's page 1, replace the list, otherwise append
      const newConversationIds = conversations.map((c) => c.id);
      const paginatedConversationIds =
        page === 1
          ? newConversationIds
          : [...state.paginatedConversationIds, ...newConversationIds];

      return {
        ...state,
        loadingMoreConversations: false,
        totalCount,
        paginatedConversationIds,
        conversationHasOlderMessages: {
          ...state.conversationHasOlderMessages,
          ...conversations.reduce(
            (acc, { id }) => ({
              ...acc,
              [id]: true,
            }),
            {}
          ),
        },
      };
    }
    case 'error': {
      return {
        ...state,
        loadingMoreConversations: false,
      };
    }
    default:
      return state;
  }
};

export default loadMoreConversations;
